<template>
  <div class="coming-soon">
    <div class="text-center">
      <b-img :src="selectionImage" class="d-block m-auto" />
      <h1 class="pt-2 w-75 font-weight-light m-auto  d-block">Choose an optimization action to view the Magic Matrix.</h1>
    </div>
  </div>
</template>
<script>
import {
  BImg
} from 'bootstrap-vue'
import { $themeColors } from '@themeConfig'

export default {
  components: {
    BImg
  },
  data () {
    return {
      // eslint-disable-next-line global-require
      selectionImage: require('@/assets/images/uploads/optimization-selection.svg'),
    }
  },
}
</script>
<style lang="scss" scoped>
.coming-soon{
  z-index: 99;
  position: absolute;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
  align-items: center;
  align-content: center;
  justify-content: center;
  justify-items: center;
  display: flex;
  border-radius: 5px;
  color: #28E9FD;
  span{
    text-align: center;
    align-self: center;
    font-size: 1.3rem;
    font-weight: 400;
  }
}
</style>
